import React from "react";
import FormWrapper from "../shared/FormWrapper";
import ProgressBar from "../shared/ProgressBar";
import AutoSaveIndicator from "../shared/AutoSaveIndicator";

export default function QualificationsExperience({
  formData,
  onInputChange,
  onContinue,
  onBack,
  onSaveAndExit,
  saving,
  lastSaved,
}) {
  return (
    <FormWrapper>
      {/* Back button */}
      <button
        onClick={onBack}
        style={{
          display: "flex",
          alignItems: "center",
          gap: "6px",
          padding: "8px 12px",
          fontSize: "14px",
          fontWeight: "500",
          color: "#737373",
          backgroundColor: "transparent",
          border: "none",
          cursor: "pointer",
          transition: "color 0.2s ease",
          marginBottom: "8px",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.color = "#1a1a1a")}
        onMouseLeave={(e) => (e.currentTarget.style.color = "#737373")}
      >
        <svg
          width="16"
          height="16"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
        >
          <polyline points="15 18 9 12 15 6" />
        </svg>
        Back
      </button>

      {/* Progress Bar */}
      <ProgressBar currentStep={2} totalSteps={5} />

      {/* Icon and Title */}
      <div
        style={{
          textAlign: "center",
          marginBottom: "32px",
          animation: "fadeInUp 0.5s ease",
        }}
      >
        <div
          style={{
            width: "48px",
            height: "48px",
            backgroundColor: "#f0fdf4",
            borderRadius: "12px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            margin: "0 auto 16px",
            border: "1px solid #d1fae5",
          }}
        >
          <svg
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
            stroke="#10b981"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <path d="M22 10v6M2 10l10-5 10 5-10 5z" />
            <path d="M6 12v5c3 3 9 3 12 0v-5" />
          </svg>
        </div>

        <h1
          style={{
            fontSize: "24px",
            fontWeight: "700",
            color: "#1a1a1a",
            marginBottom: "8px",
            letterSpacing: "-0.5px",
          }}
        >
          Your background
        </h1>
        <p
          style={{
            fontSize: "15px",
            color: "#737373",
            margin: 0,
          }}
        >
          Share your experience and qualifications
        </p>
      </div>

      {/* About you (Bio) */}
      <div
        style={{
          marginBottom: "20px",
          animation: "fadeInUp 0.5s ease 0.1s both",
        }}
      >
        <label
          style={{
            display: "block",
            fontSize: "14px",
            fontWeight: "600",
            color: "#1a1a1a",
            marginBottom: "6px",
          }}
        >
          About you
          <span style={{ color: "#a3a3a3", fontWeight: "400", marginLeft: "6px" }}>(optional)</span>
        </label>
        <p style={{ fontSize: "13px", color: "#737373", margin: "0 0 8px 0" }}>
          This will appear on your public profile
        </p>
        <textarea
          value={formData.bio}
          onChange={(e) => onInputChange("bio", e.target.value)}
          placeholder="Share a bit about yourself and your heart for ministry..."
          rows={4}
          style={{
            width: "100%",
            padding: "12px 16px",
            fontSize: "16px",
            color: "#1a1a1a",
            backgroundColor: "#fff",
            border: "1px solid #e5e5e5",
            borderRadius: "8px",
            outline: "none",
            transition: "all 0.2s ease",
            boxSizing: "border-box",
            fontFamily: "inherit",
            resize: "vertical",
          }}
          onFocus={(e) => {
            e.currentTarget.style.borderColor = "#1a1a1a";
            e.currentTarget.style.boxShadow = "0 0 0 3px rgba(26, 26, 26, 0.05)";
          }}
          onBlur={(e) => {
            e.currentTarget.style.borderColor = "#e5e5e5";
            e.currentTarget.style.boxShadow = "none";
          }}
        />
      </div>

      {/* Experience */}
      <div
        style={{
          marginBottom: "20px",
          animation: "fadeInUp 0.5s ease 0.2s both",
        }}
      >
        <label
          style={{
            display: "block",
            fontSize: "14px",
            fontWeight: "600",
            color: "#1a1a1a",
            marginBottom: "6px",
          }}
        >
          Ministry experience
          <span style={{ color: "#a3a3a3", fontWeight: "400", marginLeft: "6px" }}>(optional)</span>
        </label>
        <p style={{ fontSize: "13px", color: "#737373", margin: "0 0 8px 0" }}>
          How long have you been serving? What roles have you held?
        </p>
        <textarea
          value={formData.experience}
          onChange={(e) => onInputChange("experience", e.target.value)}
          placeholder="Tell us about your ministry journey..."
          rows={4}
          style={{
            width: "100%",
            padding: "12px 16px",
            fontSize: "16px",
            color: "#1a1a1a",
            backgroundColor: "#fff",
            border: "1px solid #e5e5e5",
            borderRadius: "8px",
            outline: "none",
            transition: "all 0.2s ease",
            boxSizing: "border-box",
            fontFamily: "inherit",
            resize: "vertical",
          }}
          onFocus={(e) => {
            e.currentTarget.style.borderColor = "#1a1a1a";
            e.currentTarget.style.boxShadow = "0 0 0 3px rgba(26, 26, 26, 0.05)";
          }}
          onBlur={(e) => {
            e.currentTarget.style.borderColor = "#e5e5e5";
            e.currentTarget.style.boxShadow = "none";
          }}
        />
      </div>

      {/* Qualifications */}
      <div
        style={{
          marginBottom: "32px",
          animation: "fadeInUp 0.5s ease 0.3s both",
        }}
      >
        <label
          style={{
            display: "block",
            fontSize: "14px",
            fontWeight: "600",
            color: "#1a1a1a",
            marginBottom: "6px",
          }}
        >
          Qualifications
          <span style={{ color: "#a3a3a3", fontWeight: "400", marginLeft: "6px" }}>(optional)</span>
        </label>
        <p style={{ fontSize: "13px", color: "#737373", margin: "0 0 8px 0" }}>
          E.g., Bible college, pastoral training, music qualifications
        </p>
        <textarea
          value={formData.qualifications}
          onChange={(e) => onInputChange("qualifications", e.target.value)}
          placeholder="Any relevant degrees, certifications, or training..."
          rows={3}
          style={{
            width: "100%",
            padding: "12px 16px",
            fontSize: "16px",
            color: "#1a1a1a",
            backgroundColor: "#fff",
            border: "1px solid #e5e5e5",
            borderRadius: "8px",
            outline: "none",
            transition: "all 0.2s ease",
            boxSizing: "border-box",
            fontFamily: "inherit",
            resize: "vertical",
          }}
          onFocus={(e) => {
            e.currentTarget.style.borderColor = "#1a1a1a";
            e.currentTarget.style.boxShadow = "0 0 0 3px rgba(26, 26, 26, 0.05)";
          }}
          onBlur={(e) => {
            e.currentTarget.style.borderColor = "#e5e5e5";
            e.currentTarget.style.boxShadow = "none";
          }}
        />
      </div>

      {/* Auto-save indicator */}
      <AutoSaveIndicator saving={saving} lastSaved={lastSaved} />

      {/* Continue Button - Dark style */}
      <button
        onClick={onContinue}
        style={{
          width: "100%",
          padding: "16px 24px",
          fontSize: "16px",
          fontWeight: "600",
          color: "#fff",
          backgroundColor: "#1a1a1a",
          border: "none",
          borderRadius: "8px",
          cursor: "pointer",
          transition: "all 0.2s ease",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          gap: "8px",
        }}
        onMouseEnter={(e) => {
          e.currentTarget.style.backgroundColor = "#333";
          e.currentTarget.style.transform = "translateY(-1px)";
        }}
        onMouseLeave={(e) => {
          e.currentTarget.style.backgroundColor = "#1a1a1a";
          e.currentTarget.style.transform = "translateY(0)";
        }}
      >
        Continue
        <svg
          width="18"
          height="18"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          strokeWidth="2"
          strokeLinecap="round"
          strokeLinejoin="round"
        >
          <line x1="5" y1="12" x2="19" y2="12" />
          <polyline points="12 5 19 12 12 19" />
        </svg>
      </button>

      {/* Skip hint */}
      <p
        style={{
          fontSize: "13px",
          color: "#a3a3a3",
          textAlign: "center",
          marginTop: "16px",
          marginBottom: "8px",
        }}
      >
        All fields are optional - you can add these details later
      </p>

      {/* Save & Exit - subtle link below */}
      <button
        onClick={onSaveAndExit}
        style={{
          width: "100%",
          padding: "12px",
          fontSize: "14px",
          fontWeight: "500",
          color: "#a3a3a3",
          backgroundColor: "transparent",
          border: "none",
          cursor: "pointer",
          transition: "color 0.2s ease",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.color = "#737373")}
        onMouseLeave={(e) => (e.currentTarget.style.color = "#a3a3a3")}
      >
        Save & finish later
      </button>
    </FormWrapper>
  );
}
